import React, { useState } from "react";
import { Icon, Modal, PasswordInput, useToast } from "./ui";
import { CreatePostModal, PostsViewer } from "./Posts";
import { FaqManager } from "../faq/FaqManager";
import { api } from "../api";

export function Header({ title, subtitle, onOpenFaq, onLogout, collapsed, onToggle, user }) {
  const [confirm, setConfirm] = useState(false);
  const [posts, setPosts] = useState(false);
  const [createPost, setCreatePost] = useState(false);
  const [settings, setSettings] = useState(false);
  const [faqMgr, setFaqMgr] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);
  const canManage = ["ADMIN", "SUPER_ADMIN", "SUPERVISOR"].includes(user?.role);
  const isSA = user?.role === "SUPER_ADMIN";

  return (
    <header className="header">
      <div className="header-brand">
        <button className="side-toggle" onClick={onToggle} title={collapsed ? "Expand menu" : "Collapse menu"} aria-label="Toggle menu">
          <Icon.chevron style={{ transform: collapsed ? "rotate(180deg)" : "none" }} />
        </button>
        <img src="/images/logo.png" alt="" className="header-logo" onError={(e) => { e.currentTarget.style.display = "none"; }} />
      </div>
      <div className="spacer" />

      <button className="icon-btn" onClick={() => setPosts(true)} title="Announcements" aria-label="Announcements"><Icon.bell width="20" height="20" /></button>

      {canManage && (
        <div className="hdr-menu-wrap">
          <button className="icon-btn" onClick={() => setSettings((s) => !s)} title="Settings" aria-label="Settings"><Icon.settings width="20" height="20" /></button>
          {settings && (
            <>
              <div className="hdr-menu-backdrop" onClick={() => setSettings(false)} />
              <div className="hdr-menu">
                <button className="hdr-menu-item" onClick={() => { setSettings(false); setCreatePost(true); }}><Icon.plus width="15" height="15" />Create post</button>
                {isSA && <button className="hdr-menu-item" onClick={() => { setSettings(false); setFaqMgr(true); }}><Icon.help width="15" height="15" />Write FAQs</button>}
                <button className="hdr-menu-item" onClick={() => { setSettings(false); setPwOpen(true); }}><Icon.shield width="15" height="15" />Change password</button>
              </div>
            </>
          )}
        </div>
      )}

      <button className="faq-btn" onClick={onOpenFaq}><Icon.help width="18" height="18" /> FAQ &amp; help</button>
      <button className="icon-btn" onClick={() => setConfirm(true)} title="Sign out" aria-label="Sign out"><Icon.logout width="20" height="20" /></button>

      {posts && <PostsViewer canManage={canManage} onClose={() => setPosts(false)} />}
      {createPost && <CreatePostModal onClose={() => setCreatePost(false)} onPosted={() => {}} />}
      {faqMgr && <FaqManager onClose={() => setFaqMgr(false)} />}
      {pwOpen && <ChangePasswordModal onClose={() => setPwOpen(false)} />}

      {confirm && (
        <Modal title="Sign out" sub="End your session" onClose={() => setConfirm(false)}
          foot={<><button className="btn btn-ghost" onClick={() => setConfirm(false)}>Cancel</button>
            <button className="btn btn-danger" onClick={() => { setConfirm(false); onLogout(); }}>Log out</button></>}>
          <p style={{ margin: 0, fontSize: "var(--fs-base)", color: "var(--ink-2)", lineHeight: 1.6 }}>
            Are you sure you want to log out? You'll need to sign in again to return to the console.
          </p>
        </Modal>
      )}
    </header>
  );
}

function ChangePasswordModal({ onClose }) {
  const toast = useToast();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async () => {
    setErr("");
    if (!cur) return setErr("Enter your current password.");
    if (nw.length < 8) return setErr("New password must be at least 8 characters.");
    if (nw !== nw2) return setErr("The new passwords don't match.");
    setBusy(true);
    try { await api.changePassword(cur, nw); toast("Password changed", "ok"); onClose(); }
    catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };
  return (
    <Modal title="Change password" sub="Update the password for your account." onClose={onClose}
      foot={<>
        <button className="btn btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={busy}>{busy ? <span className="spin" /> : "Change password"}</button>
      </>}>
      <div className="field"><label>Current password</label>
        <PasswordInput value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Enter current password" autoComplete="current-password" /></div>
      <div className="field"><label>New password</label>
        <PasswordInput value={nw} onChange={(e) => setNw(e.target.value)} placeholder="At least 8 characters" autoComplete="new-password" /></div>
      <div className="field"><label>Confirm new password</label>
        <PasswordInput value={nw2} onChange={(e) => setNw2(e.target.value)} placeholder="Re-enter new password" autoComplete="new-password" /></div>
      {err && <div className="err-text" style={{ marginTop: 4 }}>{err}</div>}
    </Modal>
  );
}